import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import "../assets/css/activity.css";
import Title from "../components/Title";
import { useSelector } from "react-redux";
import { FaTimes, FaChevronDown } from "react-icons/fa";

const Activity = () => {
  const { url, user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [queryType, setQueryType] = useState([]);

  const getActivityToken = async () => {
    try {
      const res = await axios.get(`${url}/activity_token`);
      return res.data.token[0].token;
    } catch (error) {
      console.log(error);
    }
  };

  const getActivity = async () => {
    setLoading(true);
    try {
      const token = await getActivityToken();
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/settlemyloan/sml/report/All_Activity_Time_Line?Customer_Email=${user.Email}`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.status === 200) {
        const data = res.data.data;

        // Unique query types with spaces replaced by "_"
        const temp = [
          ...new Set(
            data.map((item) => item.Query_Type.trim().replace(/\s+/g, "_")),
          ),
        ];

        setQueryType(temp);

        // Open the first accordion by default
        if (temp.length > 0) {
          setOpen(temp[0]);
        }

        // Group data using the normalized Query_Type
        const grouped = data.reduce((acc, item) => {
          const key = item.Query_Type.trim().replace(/\s+/g, "_");

          (acc[key] ||= []).push(item);

          return acc;
        }, {});

        setData(grouped);
        console.log(grouped);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);
  //
  const [replyModal, setReplyModal] = useState(false);
  const [reply, setReply] = useState({
    id: "",
    text: "",
  });
  const openReploModal = (item) => {
    setReplyModal(true);
    setReply({
      ...reply,
      id: item.ID,
    });
  };
  const handleReplyText = (e) => {
    setReply({
      ...reply,
      text: e.target.value,
    });
  };
  const [replyError, setReplyError] = useState("");
  const sendReply = async () => {
    if (!reply.text) {
      setReplyError("Enter your reply");
    } else {
      const data = [
        {
          Customer_Comments: reply.text,
        },
      ];

      const token = await getActivityToken();
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/settlemyloan/sml/report/All_Activity_Time_Line/${reply.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.data.code === 3000) {
        closeReplyModal();
        getActivity();
      } else {
        setReplyError("Something went wrong. Please try again later");
      }
    }
  };
  const closeReplyModal = () => {
    setReply({
      id: "",
      text: "",
    });
    setReplyError("");
    setReplyModal(false);
  };

  const [open, setOpen] = useState(null);

  return (
    <>
      <div className="payments-container">
        <Title title="Service Log" />
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data === null ? (
                <p className="text-center">No data found</p>
              ) : (
                <>
                  {queryType.map((type) => (
                    <div key={type} className="mb-2 acc-main-div">
                      <div
                        className="acc-header"
                        onClick={() => setOpen(open === type ? null : type)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <h2>{type.replaceAll("_", " ")}</h2>
                          <div className="acc-pill">
                            <p>{data[type].length}</p>
                          </div>
                        </div>
                        <div
                          className={`acc-triangle ${open === type && "active"}`}
                        >
                          <FaChevronDown />
                        </div>
                      </div>

                      <div className="acc-body">
                        {open === type &&
                          data[type]?.map((item, index) => (
                            <div className="service-card m-3" key={index}>
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fw-bold">Remark</p>
                                <p className="fst-italic text-secondary">
                                  {item.Date_field}
                                </p>
                              </div>
                              <p>{item.Remark}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div className={`modal-background ${replyModal ? "active" : ""}`}>
        <div className="modal-container message-modal-container py-4">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
            <p className="fw-bold">#{reply.id}</p>
            <button className="red-button" onClick={closeReplyModal}>
              <FaTimes />
            </button>
          </div>
          <div>
            <textarea
              className="input"
              value={reply.text}
              onChange={handleReplyText}
            ></textarea>
            <div className="text-end">
              <button className="button" onClick={sendReply}>
                Send
              </button>
            </div>
          </div>
          <p className="text-danger">{replyError}</p>
        </div>
      </div>
    </>
  );
};

export default Activity;
